export enum EnrollmentStatus {
	Pending = 'pending',
	Incomplete = 'incomplete',
	Paid = 'paid',
	Attached = 'attached',
	Accepted = 'accepted',
	Rejected = 'rejected',
}